/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Group_WhiteboardsInputs */

const en_hub_group_whiteboards = /** @type {(inputs: Hub_Group_WhiteboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whiteboards & workshops`)
};

const id_hub_group_whiteboards = /** @type {(inputs: Hub_Group_WhiteboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papan tulis & workshop`)
};

/**
* | output |
* | --- |
* | "Whiteboards & workshops" |
*
* @param {Hub_Group_WhiteboardsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_group_whiteboards = /** @type {((inputs?: Hub_Group_WhiteboardsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Group_WhiteboardsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_group_whiteboards(inputs)
	return en_hub_group_whiteboards(inputs)
});